var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"200px","text-align":"center","font-size":"30px"}},[_vm._v("云展台\n  \n")])}
var staticRenderFns = []

export { render, staticRenderFns }